// cleanup_convert_to_typescript_file_SMBPYMT

import { createUseStyles } from '@glu/theming';

const styles = ({
  breakpoints: {
    values: { lg, sm }
  },
  palette: { error, grey, primary, secondary, text },
  readOnly,
  spacing: { unit },
  typography: {
    mainTitle,
    headline1: { fontFamily: headlineFontFamily } = {},
    fontWeightHeavy,
    fontWeightRegular,
    fontFamily
  },
  workflow: { footer, title }
}) => ({
  [`@media only screen and (max-width: 1178px)`]: {
    warningMessage: {
      margin: [-2.5 * unit, 0, 1.25 * unit]
    }
  },
  [`@media only screen and (min-width: 1679px)`]: {
    warningMessage: {
      width: '100%'
    }
  },

  OBIwrapper: {
    position: 'relative'
  },

  alert: {
    padding: [3 * unit, 8.125 * unit, 0]
  },

  btnMore: {
    alignSelf: 'flex-start',
    fontSize: 2 * unit,
    marginLeft: 1.25 * unit,
    paddingTop: '0 !important'
  },

  calendar: {
    width: '100%'
  },

  comments: {
    '& .help-block': {
      textAlign: 'right'
    }
  },
  // The styles nested under entity are necessary to fix a Glu layout
  // issue when nesting columns three levels deep
  // To go four or more levels deep just nest the exact same '& [class^="col-"]'
  // style under the existing one for as many levels as you need
  entity: {
    '& [class^="col-"]': {
      margin: 0,
      padding: 0
    },
    alignItems: 'center',
    padding: 0
  },
  entityPopover: {
    paddingTop: unit
  },
  entityPopoverIcon: {
    padding: [3 * unit, 2 * unit, 2 * unit],
    width: 2 * unit
  },
  flexLock: {
    display: 'inline-flex'
  },
  footerAmount: {
    ...mainTitle,
    borderRight: `solid ${secondary.normal} 1px`,
    color: text.dark,
    lineHeight: `${6.25 * unit}px`,
    paddingRight: 3.75 * unit
  },
  footerButtons: {
    fontFamily: 'Roboto Condensed',
    paddingLeft: 3.75 * unit,
    display: 'flex',
    flexWrap: 'wrap',
    [`@media (max-width:${sm}px)`]: {
      flexDirection: 'column'
    },
    '& .btn': {
      [`@media (max-width:${lg}px)`]: {
        marginTop: 2 * unit,
        marginLeft: 0
      }
    }
  },
  footerItems: {
    display: 'flex',
    alignItems: 'center',
    [`@media (max-width:${sm}px)`]: {
      marginBottom: 2 * unit
    }
  },
  footerWrapper: {
    '& $footerItems $footerButtons': {
      '& button': {
        fontWeight: 'normal'
      }
    },
    '& button': {
      marginRight: 2.5 * unit
    },
    borderTop: `${secondary.normal} solid 1px`,
    color: footer.color || text.light,
    // height: 18.75 * unit,
    marginLeft: 7.5 * unit,
    paddingTop: 5 * unit,
    width: 'calc(100% - 120px)',
    [`@media (max-width:${sm}px)`]: {
      paddingTop: 2 * unit,
      marginLeft: 3.5 * unit,
      width: '85%'
    }
  },
  formBox: {
    boxShadow: '0px 1px 8px rgba(0,0,0,0.1)',
    marginBottom: 5 * unit,
    padding: [3.75 * unit, 2.875 * unit]
  },
  formBoxGroup: {
    display: 'flex'
  },
  formBoxGroupName: {},
  formBoxGroupWrapper: {
    '& h3': {
      color: '#333333',
      fontSize: 1.75 * unit,
      fontWeight: 'bold',
      paddingTop: 0.5 * unit,
      width: 25 * unit
    },
    '& h6': {
      color: text.midGray,
      fontWeight: 'normal',
      width: 15.625 * unit
    },
    display: 'flex',
    flexWrap: 'wrap'
  },
  header: {},
  help: {
    marginBottom: 0.375 * unit
  },
  hide: {
    display: 'none'
  },
  infoLabel: {
    display: 'inline-block',
    marginRight: 3 * unit,
    paddingBottom: 1.5 * unit
  },
  input: {
    width: 37.5 * unit
  },
  inputResover: {
    '& > div > svg': {
      height: 6.25 * unit,
      marginTop: 1.25 * unit,
      width: 37.5 * unit
    }
  },
  mainHeading: {
    '& button': {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      font: 'inherit',
      padding: 0,
      color: primary.normal,
      fontFamily: headlineFontFamily,
      fontSize: 2 * unit
    },
    '& h1': {
      display: 'inline-block',
      paddingRight: 2 * unit
    },
    paddingBottom: 2.5 * unit
  },
  noMargin: {
    margin: [0, -3.75 * unit]
  },
  payeeAccountContainer: {
    paddingBottom: 2 * unit,
    '& .key': {
      color: 'rgb(110, 110, 110)',
      fontSize: 1.5 * unit,
      fontWeight: 87.5 * unit
    },
    '& .value': {
      fontSize: 1.75 * unit,
      fontWeight: 50 * unit
    }
  },
  purposeHeading: {
    paddingTop: 0.625 * unit
  },
  readOnly: {
    ...readOnly
  },
  rightColumn: {
    '& .rightColRow': {
      paddingBottom: 2 * unit
    },
    boxShadow: '0px 1px 8px rgba(0,0,0,0.1)',
    padding: [4 * unit, 2.75 * unit]
  },

  rowLabel: {
    color: text.dark,
    fontSize: 1.75 * unit,
    fontWeight: fontWeightHeavy,
    textTransform: 'capitalize'
  },

  rowSubLabel: {
    color: grey.G600,
    fontSize: 1.5 * unit,
    fontWeight: fontWeightRegular,
    paddingTop: unit,
    textTransform: 'capitalize'
  },

  sectionHeading: {
    color: grey.G600,
    fontFamily,
    fontSize: 2 * unit,
    paddingBottom: 1.5 * unit
  },

  // send payment form classes
  sendPaymentForm: {
    fontFamily,
    margin: 7.5 * unit,
    [`@media only screen and (max-width: ${sm}px)`]: {
      margin: [7.5 * unit, 1.875 * unit]
    },
    '& .currencyField': {
      '& label p': {
        paddingBottom: 0.25 * unit
      },
      '& input': {
        paddingRight: unit,
        textAlign: 'right'
      }
    }
  },

  total: {
    ...title,
    alignItems: 'center',
    display: 'flex',
    minWidth: 11.875 * unit
  },

  transactionDetails: {
    '& dd': {
      '&.confInfoClass': {
        verticalAlign: 'top',
        wordBreak: 'break-all'
      },
      display: 'inline-block',
      fontSize: 1.75 * unit,
      width: '55%'
    },
    '& dl': {
      color: grey.G700,
      marginBottom: 0
    },
    '& dt': {
      display: 'inline-block',
      fontSize: 1.5 * unit,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      width: '45%'
    },
    '& h4': {
      color: text.dark,
      fontWeight: 'bold'
    },

    background: grey.G100,
    fontSize: 1.75 * unit,
    marginBottom: 4 * unit,
    padding: 2 * unit
  },

  warningMessage: {
    '&svg': {
      fill: error.dark,
      height: '20px',
      marginRight: '5px',
      width: '20px'
    },
    alignItems: 'flex-start',
    display: 'flex',
    fontFamily: 'Robato, Helvetica, Arial, sans-serif',
    fontSize: 1.5 * unit,
    margin: [-1.25 * unit, 0, 1.25 * unit, 0],
    width: '300px'
  },

  wrapper: {
    '& $formBoxGroupName': {
      color: '#6e6e6e',
      fontSize: 2 * unit,
      marginBottom: 2.375 * unit
    },
    '& $header': {
      '& h1': {
        margin: [0, 3.125 * unit, 0, 0]
      },
      '&>button': {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        font: 'inherit',
        padding: 0,
        color: primary.normal,
        fontFamily: 'Roboto Condensed',
        fontSize: 2 * unit,
        textTransform: 'capitalize'
      },
      alignItems: 'baseline',
      display: 'flex',
      marginBottom: 3.75 * unit,
      width: '100%'
    },
    '& .form-group': {
      '& .input-group': {
        zIndex: 0
      },
      '& input': {
        minWidth: 37.5 * unit
      },
      '& input[name="amount"]': {
        minWidth: 20.875 * unit,
        width: 20.875 * unit
      },
      '& label': {
        marginBottom: 0,
        minWidth: 12.5 * unit
      },
      maxWidth: 37.5 * unit
    },
    '& button': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    display: 'flex',
    flexWrap: 'wrap',
    margin: [8.5 * unit, 0, 2.5 * unit, 8.125 * unit]
  },
  dropdownLockContainer: {
    display: 'flex'
  },
  dropdownLock: {
    width: 'calc(100% - 32px)'
  },
  errorGuidMsg: {
    color: secondary.normal
  }
});

export const useStyles = createUseStyles(styles);
export default styles;
